import { Navigate } from "react-router-dom"
import { useAuthUser } from "../hooks/useAuth"
import { isFullScope, isTwoFaScope } from "../constants"
import routePaths from "../constants/path"
import FullPageLoader from "./FullPageLoader"

const OtpVerifyRoute = ({ component, requirePhase }) => {
  const { data, isLoading, isError } = useAuthUser()

  if (isLoading) return <FullPageLoader />
  if (isError || !data) return <Navigate replace to={routePaths.login} />

  if (isFullScope(data.scope)) {
    return <Navigate replace to={routePaths.homepage} />
  }

  if (!isTwoFaScope(data.scope)) {
    return <Navigate replace to={routePaths.login} />
  }

  if (requirePhase === "verify" && !data.twoFAEnabled) {
    return <Navigate replace to={routePaths.enableTwoFa} />
  }

  if (requirePhase === "setup" && data.twoFAEnabled) {
    return <Navigate replace to={routePaths.verifyTwoFa} />
  }

  return <>{component}</>
}

export default OtpVerifyRoute
